<template lang='pug'>
.err-page
  .main-container
    slot
      h1 {{__('We are sorry, but the page you are looking for cannot be found.')}}
      ul
        li {{__('If you typed the URL directly, please make sure the spelling is correct.')}}
        li {{__('If you clicked on a link to get here, we must have moved the content.')}}
        li {{__('Please try our store search box above to search for an item.')}}
        li(v-html=`__("If you are not sure how you got here, <a href='{home}'>return to our store homepage</a>.", {home: $router.resolve('/').href})`)
  FeaturedProducts.featured.main-container
  ProductCarousel.main-container.products(
    :widget="widget"
    title="Recommended Products"
    :podId="PODS.JUST_FOR_YOU"
  )
</template>

<script setup lang="ts">
import FeaturedProducts from '@/js/pages/home/FeaturedProducts.vue'
import { widgets } from '@/js/services/rfk/types'
import { PODS } from '@/js/services/cnstrc/constants'

const widget = widgets.SEARCH_EMPTY
</script>

<style scoped lang="scss">
.products,
.featured,
.err-page {
  margin-top: $space-xxxl;
}

.products {
  margin-bottom: $space-xxl;
}
</style>
